var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.578125,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#AF6CC7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4634 18.5719C31.4636 17.5717 32.8201 17.0098 34.2346 17.0098C35.6491 17.0098 37.0056 17.5717 38.0058 18.5719C40.0886 20.6547 40.0886 24.0316 38.0058 26.1144L35.1774 28.9428C34.6567 29.4635 34.6567 30.3077 35.1774 30.8284C35.6981 31.3491 36.5423 31.3491 37.063 30.8284L39.8915 28C43.0157 24.8758 43.0157 19.8105 39.8915 16.6863C38.3912 15.186 36.3563 14.3431 34.2346 14.3431C32.1129 14.3431 30.078 15.186 28.5778 16.6863L25.7493 19.5147C25.2286 20.0354 25.2286 20.8796 25.7493 21.4003C26.27 21.921 27.1142 21.921 27.6349 21.4003L30.4634 18.5719Z",
    fill: "#AF6CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9781 27.0572C22.4988 26.5365 22.4988 25.6923 21.9781 25.1716C21.4574 24.6509 20.6132 24.6509 20.0925 25.1716L17.264 28C14.1398 31.1242 14.1398 36.1895 17.264 39.3137C18.7643 40.814 20.7992 41.6568 22.9209 41.6568C25.0426 41.6568 27.0775 40.814 28.5778 39.3137L31.4062 36.4853C31.9269 35.9646 31.9269 35.1204 31.4062 34.5997C30.8855 34.079 30.0413 34.079 29.5206 34.5997L26.6921 37.4281C25.6919 38.4283 24.3354 38.9902 22.9209 38.9902C21.5064 38.9902 20.1499 38.4283 19.1497 37.4281C17.0669 35.3453 17.0669 31.9684 19.1497 29.8856L21.9781 27.0572Z",
    fill: "#AF6CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8638 30.8284C23.3431 31.3491 23.3431 32.1933 23.8638 32.714C24.3845 33.2347 25.2287 33.2347 25.7494 32.714L33.2919 25.1716C33.8126 24.6509 33.8126 23.8067 33.2919 23.286C32.7712 22.7653 31.927 22.7653 31.4063 23.286L23.8638 30.8284Z",
    fill: "#AF6CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef);
export default __webpack_public_path__ + "static/media/ref.c55610b0aecc2242b98bfa9753161357.svg";
export { ForwardRef as ReactComponent };